import React from 'react';
import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef, myVulnerabilitiesRouteRef } from './routes';

const reportsPage = PageBlueprint.make({
  params: {
    path: '/reports',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ReportsPage').then(m => <m.ReportsPage />),
  },
});

const myVulnerabilitiesPage = PageBlueprint.make({
  name: 'my-vulnerabilities',
  params: {
    path: '/reports/my-vulnerabilities',
    routeRef: myVulnerabilitiesRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/MyVulnerabilitiesPage').then(m => <m.MyVulnerabilitiesPage />),
  },
});

const plugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'reports',
  extensions: [reportsPage, myVulnerabilitiesPage],
  routes: {
    root: rootRouteRef,
    myVulnerabilities: myVulnerabilitiesRouteRef,
  },
});
export default plugin;
